import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import MarketingLayout from '$components/MarketingLayout';
import MailchimpSignup from '$components/MailchimpSignup';
import Hero from '$components/Hero';
import { Flex, Col } from '$components/Flex';
import MarketingSection from '$components/MarketingSection';
import MarketingDivide from '$components/MarketingDivide';
import MarketingCodebox from '$components/MarketingCodebox';
import MarketingBullets from '$components/MarketingBullets';
import postgresPostgraphileGraphql from '$images/postgres_postgraphile_graphql.png';
import Testimonial from '$components/MarketingTestimonial';
export const _frontmatter = {
  "layout": "marketing",
  "path": "/postgraphile/",
  "title": "PostGraphile - full GraphQL API server in an instant from PostgreSQL database"
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <MarketingLayout blue mdxType="MarketingLayout">
      <Hero bg="white" mdxType="Hero">
        <h2>{`PostGraphile Instant GraphQL API`}</h2>
        <br />
        <div className='flex'>
          <a className='button--solid-light' href='/postgraphile/introduction/'><span className='fas fa-book-open' /> Documentation <span className='fas fa-fw fa-arrow-right' /></a>
        </div>
        <div className='flex'>
          <div style={{
            margin: '0 0.5rem 0 0'
          }}><a className='button--solid' href='https://discord.gg/graphile'><span className='fab fa-discord' /> Join Chat</a></div>
          <div style={{
            margin: '0 0.5rem 0 0'
          }}><a className='button--solid' href='https://github.com/graphile/postgraphile'><span className='fas fa-star' /> View on GitHub</a></div>
        </div>
      </Hero>
      <MarketingSection bg="white" mdxType="MarketingSection">
        <Flex mdxType="Flex">
          <Col className="center" span="8" mdxType="Col">
            <img src={postgresPostgraphileGraphql} style={{
              maxWidth: '100%'
            }} />
          </Col>
        </Flex>
      </MarketingSection>
      <MarketingDivide from="white" to="dark" mdxType="MarketingDivide" />
      <MarketingSection bg="dark" mdxType="MarketingSection">
        <Flex mdxType="Flex">
          <Col span="8" offset="2" className='tc' mdxType="Col">
            <h3>{`Instantly spin-up a GraphQL API server by pointing PostGraphile at your existing PostgreSQL database`}</h3>
          </Col>
        </Flex>
      </MarketingSection>
      <MarketingDivide from="dark" to="light" via="medium" mdxType="MarketingDivide" />
      <MarketingSection bg="light" mdxType="MarketingSection">
        <MarketingCodebox mdxType="MarketingCodebox">
          <big>Try it now:</big>
          <div className='mv4'>
            <big><code>npx postgraphile -c my_db --watch</code></big>
          </div>
          <small><em>requires Node.js 8.6 or higher</em></small>
        </MarketingCodebox>
        <p className='f7'>
If your database is on another machine, you may pass a connection string in place of <tt>my_db</tt>. Connection strings have the form:
        </p>
        <p className='f7'>
          <tt>postgres://pg_user:pg_pass@pg_host:pg_port/pg_db?ssl=1</tt>
        </p>
      </MarketingSection>
      <MarketingDivide from="light" to="nodes" via="medium" down mdxType="MarketingDivide" />
      <MarketingSection bg="nodes" mdxType="MarketingSection">
        <div style={{
          maxWidth: '48em',
          margin: 'auto'
        }}>
          <h3>{`Rapidly develop lightning-fast powerful applications`}</h3>
          <big>PostGraphile automatically detects tables, columns, indexes, relationships,
views, types, functions, comments, and more &mdash; providing a GraphQL server that
is highly intelligent about your data, and that automatically updates itself
without restarting when you modify your database.</big>
          <MarketingBullets bullets={['Strong PostgreSQL support', 'GraphQL best practices', 'Simple to deploy and scale', 'Highly customisable', 'Impressively high performance', 'Granular authorisation via RLS', 'Open source under MIT license', 'Powerful plugin system']} mdxType="MarketingBullets" />
        </div>
      </MarketingSection>
      <MarketingDivide from="nodes" to="dark" via="medium" mdxType="MarketingDivide" />
      <MarketingSection bg="dark" mdxType="MarketingSection">
        <h3>{`What people are saying`}</h3>
        <div className="mw9 ph3-ns flex flex-wrap justify-between">
          <Testimonial name="Chad F" role="senior technical lead" link="https://chads.website/development/2018/08/03/How-GraphQL-Saved-My-Project.html" mdxType="Testimonial">
  Thanks for making GraphQL something I can use on my project in a robust way
  with <strong>minimal effort</strong>. 500-1500 requests per second on a
  single server is pretty awesome.
          </Testimonial>
          <Testimonial name="Sam L" role="full stack developer" link="https://gitter.im/graphile/postgraphile?at=5b65d555e9ab53770c8c41a1" mdxType="Testimonial">
  This project, Benjie's handling of it, the docs, support, and community is
  awesome all around. <strong>PostGraphile is a powerful, idomatic, and elegant
  tool.</strong>
          </Testimonial>
          <Testimonial name="Max D" role="software consultant" link="https://twitter.com/maxdesiatov/status/1001419221102940160" linkIcon="fab fa-twitter" mdxType="Testimonial">
  Recently I launched a few mobile and web apps using GraphQL, Great stuff, not
  least thanks to wonderful PostGraphile and Apollo. <strong>At this point,
  it’s quite hard for me to come back and enjoy working with
  REST.</strong>
          </Testimonial>
          <Testimonial name="Bradley A" role="CTO" link="https://twitter.com/bradleyayers/status/1012557510346080256" linkIcon='fab fa-twitter' mdxType="Testimonial">
  I setup my backend to use PostGraphile directly when querying the local
  database. It's removed a bunch of hand-written SQL, added type-safety to
  verify Postgres schema compatibility, and <strong>created a more consistent
  dev experience for frontend/backend code.</strong>
          </Testimonial>
          <Testimonial name="Steven M" role="VP engineering" mdxType="Testimonial">
  Our company is under going a technology shift to use more a more modern
  stack. A large piece of this shift is our desire to use a GraphQL interface
  to our Postgres server. After researchiing we decided to try PostGraphile
  from the graphile.org site and <strong>we couldn't be happier</strong>.
  It's very expansive and configurable and the maintainers are available to
  ask questions and it's nice to see such an active group fixing bugs and
  adding enhancements. We're very happy with our choice!
          </Testimonial>
        </div>
      </MarketingSection>
      <MarketingDivide from="dark" to="light" down mdxType="MarketingDivide" />
      <MarketingSection bg="light" mdxType="MarketingSection">
        <MailchimpSignup mdxType="MailchimpSignup" />
      </MarketingSection>
      <MarketingDivide from="light" to="medium" mdxType="MarketingDivide" />
      <MarketingSection bg="medium" mdxType="MarketingSection">
        <MarketingBullets bullets={[['Client-facing GraphQL server', 'No need for complex server architectures, containers, etc: PostGraphile is pure Node.js and can be embedded in your existing Node.js project'], ['Server-side rendering', 'Issue requests to your PostGraphile API without network roundtrips, fantastic for React SSR'], ['Hot-reloading GraphQL API', 'Automatically re-generate the GraphQL schema when your database changes when you\'re using `--watch`'], ['Lightning fast', 'Much faster [performance](/postgraphile/performance/) than even a hand-rolled GraphQL schema using `DataLoader`'], ['No N+1 problem', 'PostGraphile compiles a query tree of any depth into a single SQL statement, resulting in extremely efficient execution'], ['Auto-generated documentation', 'Database comments are exported to GraphQL and browsable via the built in PostGraphiQL IDE'], ['GraphQL best practices', 'Including: [cursor pagination](https://facebook.github.io/relay/graphql/connections.htm), [global object identification](https://facebook.github.io/relay/graphql/objectidentification.htm), and [Relay mutations](https://facebook.github.io/relay/graphql/mutations.htm)'], ['Super secure', 'Implement authorization via PostgreSQL\'s RBAC and Row-Level Security features, get full-stack security you can trust'], ['Respects database permissions', 'Tables and columns that you don\'t `GRANT` access to will not be exported via GraphQL when using `--no-ignore-rbac`'], ['Customisable with SQL', 'Excellent PostgreSQL function support, mapping to [custom queries](/postgraphile/custom-queries/), [custom mutations](/postgraphile/custom-mutations/) and [computed columns](/postgraphile/computed-columns/)'], ['Customisable via smart-comments', 'Refine your GraphQL schema with [smart comments](/postgraphile/smart-comments/): rename, omit, enhance with a simple `COMMENT`'], ['Customisable via JS', 'PostGraphile is built from a large number of plugins; get the exact API you desire by replacing or removing existing plugins, building your own with our helpers, or selecting from community plugins'], ['Fully GraphQL compatible', 'We use the [reference GraphQL implementation](http://graphql.org/graphql-js/) under the hood, so you know we\'re spec compliant']]} mdxType="MarketingBullets" />
      </MarketingSection>
    </MarketingLayout>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      